const icons: Record<string, string> = {
  'icecream-icon': new URL('@/assets/icecream-icon.svg', import.meta.url).href,
  'h_goods': new URL('@/assets/h_goods.svg', import.meta.url).href,
  'products': new URL('@/assets/products.svg', import.meta.url).href,
  'zagotovka': new URL('@/assets/zagotovka.svg', import.meta.url).href,
  'drinks': new URL('@/assets/drinks.svg', import.meta.url).href,
  'beer': new URL('@/assets/beer.svg', import.meta.url).href,
  'gift': new URL('@/assets/gift.svg', import.meta.url).href,
  'hotter': new URL('@/assets/hotter.svg', import.meta.url).href,
  'limonade': new URL('@/assets/limonade.svg', import.meta.url).href,
  'r_made': new URL('@/assets/r_made.svg', import.meta.url).href,
};

export default icons;